(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/hbs-helpers.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/hbs-helpers.js');

'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var svsuid = svs.utils.svsuid;
var _ref = svs.isServer ? require("".concat(__dirname, "/to-array-or-null.es6")) : svs.content.image_v2.helpers,
  toArrayOrNull = _ref.toArrayOrNull;
var getImageUrl = function getImageUrl(url, config) {
  return url !== null && url !== void 0 && url.startsWith('http') ? url : "".concat(config.options.cdn2).concat(url);
};
var getImage = function getImage(image) {
  var _image$url;
  return image !== null && image !== void 0 && image.legacy ? image === null || image === void 0 ? void 0 : image.url : (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.replace('-{width}', '');
};

function registerHelpers(hbs, config) {
  var handlebarsHelpers = {
    getUniqueSelector: function getUniqueSelector() {
      return "image-".concat(svsuid());
    },
    newImageSrcset: function newImageSrcset(image) {
      var extension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var srcset = [];
      var regex = /({width}|%7Bwidth%7D)/g;
      var cleanedExtension = typeof extension === 'string' && extension.replace(/\./g, '');
      var availableWidths = image.availableWidths || ['noAvailableWidths'];
      var imageUrl = getImage(image);
      if (!image.isPreview && typeof cleanedExtension === 'string') {
        imageUrl = image !== null && image !== void 0 && image.legacy ? "".concat(image.url.substr(0, image.url.lastIndexOf('.')), ".").concat(cleanedExtension) : imageUrl.replace('{extension}', cleanedExtension);
      }
      availableWidths.forEach(function (size) {
        var _image$aspectRatio, _imageUrl;
        var width = size === 'original' && image !== null && image !== void 0 && image.legacy ? image === null || image === void 0 ? void 0 : (_image$aspectRatio = image.aspectRatio) === null || _image$aspectRatio === void 0 ? void 0 : _image$aspectRatio.width : size;
        var useOriginal = function useOriginal(width) {
          return !width || width === 'original' || width === 'noAvailableWidths' ? '' : "".concat(width, "w");
        };
        var url = getImageUrl((_imageUrl = imageUrl) === null || _imageUrl === void 0 ? void 0 : _imageUrl.replace(regex, width), config);
        srcset.push("".concat(url, " ").concat(useOriginal(width)));
      });
      return new hbs.SafeString(srcset.join(','));
    },
    originalImageSrcset: function originalImageSrcset(image) {
      var _getImage;
      var regex = /({width}|%7Bwidth%7D)/g;
      var srcset = (_getImage = getImage(image)) === null || _getImage === void 0 ? void 0 : _getImage.replace('{extension}', 'original').replace(regex, 'original');
      return new hbs.SafeString(srcset);
    },
    setVar: function setVar(name, value) {
      this[name] = value;
    },
    strinigfyImagesObject: function strinigfyImagesObject(input) {
      var imagesArray = toArrayOrNull(input);
      if (imagesArray) {
        var customImagesArray = imagesArray.map(function (item) {
          return item ? {
            aspectRatio: item.aspectRatio,
            dominantColor: item.dominantColor,
            media: item.media
          } : undefined;
        });
        return JSON.stringify(customImagesArray);
      }
      return null;
    },
    setStyleElement: function setStyleElement(selector, imagesObject) {
      if (svs.isBrowser) {
        var setStyleElement = svs.content.image_v2.helpers.multiImageStyleElement.setStyleElement;
        setStyleElement(selector, imagesObject);
      }
    },
    getNoscriptUrl: function getNoscriptUrl(data) {
      var _url$replace;
      var noscriptUrl = data.noscriptUrl,
        url = data.url,
        availableWidths = data.availableWidths;
      if (noscriptUrl) {
        return getImageUrl(noscriptUrl, config);
      }
      var fallbackWidth = 1280;
      var hasAvailableWidths = availableWidths === null || availableWidths === void 0 ? void 0 : availableWidths.length;
      var width = hasAvailableWidths ? Math.max.apply(Math, _toConsumableArray(availableWidths)) : String(fallbackWidth);
      var fixedUrl = (_url$replace = url === null || url === void 0 ? void 0 : url.replace('{width}', width)) !== null && _url$replace !== void 0 ? _url$replace : '';
      return getImageUrl(fixedUrl, config);
    }
  };

  for (var helperName in handlebarsHelpers) {
    if (helperName in handlebarsHelpers) {
      hbs.registerHelper(helperName, handlebarsHelpers[helperName]);
    }
  }
}
if (svs.isServer) {
  var _require = require('trinidad-core'),
    core = _require.core;
  registerHelpers(require('hbs'), core.config);
} else {
  var config = {
    options: svs.core.config.data.svsconfig
  };
  registerHelpers(Handlebars, config);
}

 })(window);